import { Loadable } from 'utils/components'
import { LIST_REQUESTS_PATH as path } from 'constants/paths'

export default {
  path,
  component: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: 'List Requests' */ './components/ListRequestsPage'
      )
  })
}
